




























































































































interface DropTitle {
    isDim: number;
    isNumCurr: number;
    isNum: number;
    isCurr: number;
}
interface SubVal {
    id: number;
    no: string;
    longText: string;
}
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { DatePickerOptions } from "element-ui/types/date-picker";
import { mapGetters } from "vuex";
import MonthSelectorVue from "../MonthSelector.vue";
import SideNavVue from "../SideNav.vue";
import SubjectAssistBalanceVue from "../Balance/SubjectAssistBalance.vue";
import CurrencyAndSumDialogVue from "../Balance/CurrencyAndSumDialog.vue";
import SubsidiaryLedgerVue from "../../views/SubsidiaryLedger.vue";
@Component({
    components: {
        "month-selector": MonthSelectorVue,
        "side-nav": SideNavVue,
        "subjectAssist-balance": SubjectAssistBalanceVue,
        "currencyAndSum-dialog": CurrencyAndSumDialogVue,
        "subsisiary-dialog": SubsidiaryLedgerVue
    }
})
export default class AnnualEITBalance extends Vue {
    @Prop({ type: Array })
    appointDate?: Date[];

    @Prop({ type: Date })
    dateYear: any;

    @Prop({ type: Boolean })
    isDialog?: boolean;

    @Prop({ type: Boolean })
    isAnnual?: boolean;

    dropTitle: DropTitle = {
        isDim: 0,
        isNumCurr: 0,
        isNum: 0,
        isCurr: 0
    };
    balContentNowYear: boolean = false; //是否展示本年累计
    isRetract: boolean = true; //展开收起
    currentAccountTypeName: string = "";
    tableData: Balance.Balance[] = [];
    iconIndex: number | null = null;

    // 是否展示查看明细帐的icon
    showIcon(i: number) {
        this.iconIndex = i;
    }
    offIcon() {
        this.iconIndex = null;
    }
    //改变时间
    period: String[] = []; // 日期
    dailogDate: any = [];//弹窗日期
    changeDate(date: string[]) {
        this.startPeriod = date[0];
        this.endPeriod = date[1];
    }
    startPeriod: string = "";
    endPeriod: string = "";
    //科目弹窗中的时间
    get yearMonth() {
        if (this.startPeriod === this.endPeriod) {
            return (
                this.startPeriod.substring(0, 4) +
                "年" +
                this.startPeriod.substring(4) +
                "月"
            );
        } else {
            return (
                this.startPeriod.substring(0, 4) +
                "年" +
                this.startPeriod.substring(4) +
                "月至" +
                this.endPeriod.substring(0, 4) +
                "年" +
                this.endPeriod.substring(4) +
                "月"
            );
        }
    }

    // 余额表选择下拉
    dialogStatusNum: string = "";
    dialogTitle: string = "";
    handleCommand(command: string) {
        this.dialogStatusNum = command;
        if (command == "科目辅助余额表") {
            this.isSubBalance = true;
        } else if (command == "1") {
            this.dialogTitle = "数量金额余额表";
            this.isCurrencyNum = true;
        } else if (command == "2") {
            this.dialogTitle = "外币金额余额表";
            this.isCurrencyNum = true;
        } else if (command == "3") {
            this.dialogTitle = "数量外币余额表";
            this.isCurrencyNum = true;
        }
    }

    // 科目辅助余额表弹窗是否打开
    isSubBalance: boolean = false;
    closeSubBalance() {
        this.isSubBalance = false;
    }

    isCurrencyNum: boolean = false;
    closeCurrencyNum() {
        this.isCurrencyNum = false;
    }

    // 是否下拉
    get dropDownIcon() {
        if (
            this.dropTitle.isDim != 0 ||
            this.dropTitle.isNumCurr != 0 ||
            this.dropTitle.isNum != 0 ||
            this.dropTitle.isCurr != 0
        ) {
            return true;
        } else {
            return false;
        }
    }

    // 监听本年累计
    @Watch("balContentNowYear")
    yearChange() {
        this.fetchData()
    }

    @Watch("dateYear",{deep:true})
    year(val:any) {
          let time = val
          let year =this.$utils.simpleDateFormat(time, "m").substr(0, 4) + "12"
          let day=this.$utils.strToDate(year + "01")
          this.period=[year,year]
          this.dailogDate=[day,day]
          this.fetchData()
    }

    mounted(){
        if(this.isAnnual) this.balContentNowYear = true
        if(this.dateYear){
          let time = this.dateYear
          let year =this.$utils.simpleDateFormat(time, "m").substr(0, 4) + "12"
          let day=this.$utils.strToDate(year + "01")
          this.period=[year,year]
          this.dailogDate=[day,day]
          this.fetchData()
        }
    }
    // 获取表格数据
    fetchData() {
        Vue.axios
            .post(`balances/find`, {
                accountBookId: this.$store.state.accountBook.id,
                buttonStatus: 0,
                isBNLJ: this.balContentNowYear ? 1 : 0,
                startPeriod: this.period[0],
                endPeriod: this.period[1]
            })
            .then(res => {
                this.tableData = res.data.balances;
                this.dropTitle.isDim = res.data.isDim;
                this.dropTitle.isCurr = res.data.isCurr;
                this.dropTitle.isNum = res.data.isNum;
                this.dropTitle.isNumCurr = res.data.isNumCurr;
            });
    }

    // 明细账模态框
    showSubsidiary: boolean = false;
    relation: Assist.Relation | null = null; //明细账弹窗的relation
    subVal: SubVal = {
        id: 0,
        no: "",
        longText: ""
    };
    subsidiary(data: Balance.Balance) {
        this.subVal.id = data.subjectId;
        this.subVal.no = data.no;
        this.subVal.longText = data.text;
        this.relation = data.relation;
        this.showSubsidiary = true;
    }

    // 全部收起展开 按钮
    spreadOut(val: boolean) {
        let conRow_data_num: any = document.querySelectorAll(
            ".con-row[data-num]"
        );
        let conRow_balItem_i: any = document.querySelectorAll(
            "#AnnualEITBalance .con-row .bal-item i"
        );
        if (val) {
            for (let i = 0; i < conRow_data_num.length; i++) {
                conRow_data_num[i].style.display = "";
            }
            for (let i = 0; i < conRow_balItem_i.length; i++) {
                conRow_balItem_i[i].setAttribute(
                    "class",
                    "el-icon-caret-bottom"
                );
            }
        } else {
            for (let i = 0; i < conRow_data_num.length; i++) {
                conRow_data_num[i].style.display = "none";
            }
            for (let i = 0; i < conRow_balItem_i.length; i++) {
                conRow_balItem_i[i].setAttribute(
                    "class",
                    "el-icon-caret-right"
                );
            }
        }
    }

    // 点击 收起展开 图标
    iconEdit(data: Balance.Balance, el: Event) {
        let re: any = new RegExp(data.no);
        let conRow_data_num: any = document.querySelectorAll(
            ".con-row[data-num]"
        );
        let target: HTMLElement = <HTMLElement>el.currentTarget;
        if (target.getAttribute("class") == "el-icon-caret-bottom") {
            target.setAttribute("class", "el-icon-caret-right");
            for (let i = 0; i < conRow_data_num.length; i++) {
                if (re.test(conRow_data_num[i].getAttribute("data-num"))) {
                    conRow_data_num[i].style.display = "none";
                }
            }
        } else {
            target.setAttribute("class", "el-icon-caret-bottom");
            this.openIcon(data.no);
        }
        if (
            document.querySelectorAll("#AnnualEITBalance .con-row i.el-icon-caret-right")
                .length > 0
        ) {
            this.isRetract = false;
        } else {
            this.isRetract = true;
        }
    }

    //展开图标
    openIcon(no: string) {
        let conRow_data_num: any = document.querySelectorAll(
            ".con-row[data-num]"
        );
        for (let i = 0; i < conRow_data_num.length; i++) {
            if (conRow_data_num[i].getAttribute("data-num") == no) {
                let elementTrData: any = conRow_data_num[i].getAttribute(
                    "data-no"
                );
                conRow_data_num[i].style.display = "";
                if (
                    conRow_data_num[i].querySelector(".indent-div i") != null &&
                    conRow_data_num[i]
                        .querySelector(".indent-div i")
                        .getAttribute("class") == "el-icon-caret-bottom"
                ) {
                    this.openIcon(elementTrData);
                }
            }
        }
    }

    // indent 的值
    showIndent(data: Balance.Balance) {
        if (data.isLeaf != 0 && data.level == 1) {
            return "indent1";
        } else if (data.isLeaf === 0 && data.level === 2) {
            return "indent2 ";
        } else if (data.isLeaf != 0 && data.level === 2) {
            return "indent2-1";
        } else if (data.isLeaf === 0 && data.level === 3) {
            return "indent3";
        } else if (data.isLeaf != 0 && data.level === 3) {
            return "indent3-1";
        } else if (data.isLeaf === 0 && data.level === 4) {
            return "indent4";
        } else if (data.isLeaf != 0 && data.level === 4) {
            return "indent4-1";
        } else if (data.isLeaf === 0 && data.level === 5) {
            return "indent5";
        } else if (data.isLeaf != 0 && data.level === 5) {
            return "indent5-1";
        } else if (data.isLeaf != 0 && data.level === 6) {
            return "indent6-1";
        }
    }

    // 点击侧边按钮
    accItem(item: NavList) {
        let elements: any = document.querySelectorAll(".con-row");
        if (item.number) {
            for (let i = 0; i < elements.length; i++) {
                if (
                    elements[i].getAttribute("subtypeCode") ==
                    item.number.toString()
                ) {
                    let autoScroll: any = document.querySelector(
                        "#AnnualEITBalance .auto-scroll"
                    );
                    autoScroll.scrollTop = elements[i].offsetTop;
                    break;
                }
            }
        }
    }
}
